<template>
  <v-container fluid style="padding:0" :key="mipchange">
      <!-- <v-form :disabled="readonly" ref="mipsform" v-model="mipsValidL"> -->
        <v-row no-gutters class="mb-0 mx-0" style="margin-left:-16px !important;margin-right:-16px !important;">
            <!-- <v-col cols="12">
                <v-btn block outlined @click="evaluateMIPs()">EVALUATE MIPS</v-btn>
            </v-col> -->
            <v-col cols="12" v-if="activeEnc.codes.mips && activeEnc.codes.mips.length>0">
                <v-expansion-panels 
                    :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                    :dark="proMode" 
                    v-model="mipsPanels" 
                    multiple 
                    accordion
                    tile
                >
                    <v-expansion-panel
                        v-for="(mip,mipsind) in activeEnc.codes.mips"
                        :key="mipsind"
                    >
                        <div v-if="mipsSelected[mip.mip_id]">
                            <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'font-weight:bold;border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                                #{{mip.mip}}: {{(mipsSelected[mip.mip_id].name ? mipsSelected[mip.mip_id].name : "")}}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="pt-0" :key="msc">
                                <v-stepper class="step50" v-model="mSteppers[mipsind]" non-linear>
                                    <v-stepper-header>
                                        <div v-for="(step, stepind) in mipsSelected[mip.mip_id].numerator.steps" :key="mipsind + '_' + step.code + '_' + stepind">
                                            <v-stepper-step
                                                complete
                                                complete-icon="mdi-check"
                                                :step="(stepind+1)"
                                                :editable="!readonly"
                                                edit-icon="mdi-check"
                                                error-icon="mdi-close"
                                                :color="(mipSelects[mip.mip_id][stepind] ? 'success' : 'secondary')"
                                                :rules="[() => mipSelects[mip.mip_id][stepind]]"
                                                @click="goToStep(mip.mip_id,stepind)"
                                            >
                                                {{(step.code ? step.code : "N/A")}}
                                            </v-stepper-step>
                                            <v-divider></v-divider>
                                        </div>
                                    </v-stepper-header>
                                    <v-stepper-items>
                                        <v-stepper-content 
                                            v-for="(step, stepind) in mipsSelected[mip.mip_id].numerator.steps"
                                            :key="mipsind + '_' + step.code + '_' + stepind"
                                            :step="(stepind+1)"
                                        >
                                            <v-row no-gutters>
                                                <v-col cols="1">
                                                    <v-checkbox
                                                        v-model="mipSelects[mip.mip_id][stepind]"
                                                        @change="mipCodeChecked(mipSelects[mip.mip_id][stepind],mipsind,mip.mip_id,step.code)"
                                                        hide-details
                                                        class="largeCbox"
                                                    ></v-checkbox>
                                                </v-col>
                                                <v-col cols="11">
                                                    <v-expansion-panels focusable class="mb-6" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                                                        <v-expansion-panel>
                                                            <v-expansion-panel-header class="font-weight-bold">{{(step.code ? step.code : "N/A")}} - {{step.description}}</v-expansion-panel-header>
                                                            <v-expansion-panel-content class="pa-2" style="white-space: break-spaces;">
                                                                {{step.definition}}
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row no-gutters>
                                                <v-col cols="3">
                                                    <v-btn :disabled="readonly" v-if="stepind > 0" color="secondary" outlined block @click="mipStepChange('B',mipsind,stepind,mip.mip_id)">
                                                        Previous Code
                                                    </v-btn>
                                                </v-col>
                                                <v-spacer></v-spacer>
                                                <v-col cols="3">
                                                    <v-btn
                                                        block
                                                        color="secondary"
                                                        @click="mipStepChange('F',mipsind,stepind,mip.mip_id)"
                                                        v-if="stepind < mipsSelected[mip.mip_id].numerator.steps.length-1"
                                                        :disabled="mipSelects[mip.mip_id][stepind] || readonly"
                                                    >
                                                        Next Code
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>
                            </v-expansion-panel-content>
                        </div>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <!-- <v-row no-gutters>
            <v-col cols="12" class="mt-2">
                <v-btn v-if="lastChanceUndo" class="my-2" small block color="warning" @click="undoResults">Undo Clear All ({{undoTimeLeft}}s left)</v-btn>
                <v-btn v-else class="my-2" :disabled="readonly" small block color="error" @click="clearResultsDialog">Clear All Entries</v-btn>
            </v-col>
        </v-row> -->
    <!-- </v-form> -->
    <v-dialog
        v-model="clearResDiag"
        width="350"
    >
        <v-card>
            <v-card-title class="headline red darken-2 white--text pl-4 pb-2">
            Are you sure?
            </v-card-title>

            <v-card-text class="pt-5">
            This will remove all results that have been entered to this point. You have spent {{timeSinceOpen}} mins on this chart, please be sure before proceeding.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="clearResults"
            >
                Confirm Clear Results
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { ulid } from 'ulid';

export default{
  name: 'MIPS',
    props: {
        aeUp:{
            type:Number,
            required:true
        },
        activeEnc:{
            type:Object,
            required:true
        },
        activeQaEnc:{
            type:Object,
            required:false
        },
        timeOpened:{
            type:Number,
            required:true
        },
        mipsValid:{
            type:Boolean,
            required:false
        },
        qaEnc:{
            type:Boolean,
            required:false
        },
        readonly:{
            type:Boolean,
            required:false
        },
    },
    components: { 
    },
    data() {
        return {
            isLoading:false,
            mipsValidL:false,
            undoEnc:{},
            lastChanceUndo:false,
            countdownInt:null,
            undoTimeLeft:15,
            timeSinceOpen:0,
            clearResDiag: false,

            descriptionLimit: 50,
            entries: [],
            isLoading: false,
            model: null,
            searchAPI:null,

            mipchange: 0,

            mipsPanels:[],
            mSteppers: [],
            msc:0,
            mipsSelected: {},
            mipSelects: {},

            menu1:[false],
            restab:"",
            difRes: false,

            fieldRule: function(v,f){
                let out = true;
                // if(this.reqCheck(f) && !v){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
            fieldRuleDep: function(v,f,df){
                let out = true;
                if(df && this.reqCheck(f) && !v){
                    //out = 'Field Required to QA/Complete';
                    out='';
                }else{
                }
                return [out];
            },
            fieldRuleInd: function(v,f,ind){
                // let fArr = f.split("_"),
                //     fComb = fArr[0] + "_" + ind + "_" + fArr[1];
                let out = true;
                // if(this.reqCheck(fComb) && !v.code){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
        };
    },
    computed:{
        ...mapGetters(["facSettings","noCalc","proMode","mipsMeasures"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
    },
    watch:{
      mipsValidL(val){
          this.$emit('validChanged', val);
      },
      aeUp(val){
          //// console.log("AE CHANGE");
          this.evaluateMIPs();
      }
    },
    mounted: function(){
        //// console.log("MIPS MOUNTED");
        if(!this.activeEnc.codes.mips){
            this.activeEnc.codes.mips = [];
        }
        this.evaluateMIPs();
    },
    // beforeMount: function() {
    //     
    // },
    methods: {
        evaluateMIPs(){
            //// console.log("EVAL MIPS");
            let out = [],
                age = (this.activeEnc.demographics.age ? this.activeEnc.demographics.age : this.ageTator(this.activeEnc.demographics.dob)),
                gender = this.activeEnc.demographics.gender.toUpperCase(),
                types = Object.keys(this.activeEnc.codes),
                codes = [];
            for(let t=0; t<types.length; t++){
                if(types[t] != "mips"){
                    for (let d=0; d<this.activeEnc.codes[types[t]].doss.length; d++){
                        if(types[t] != "dx"){
                            let ctypes = Object.keys(this.activeEnc.codes[types[t]].doss[d]);
                            for (let ct=0; ct<ctypes.length; ct++){
                                if(ctypes[ct] != "dos"){
                                    for (let c=0; c<this.activeEnc.codes[types[t]].doss[d][ctypes[ct]].length; c++){
                                        let codeOut = JSON.parse(JSON.stringify(this.activeEnc.codes[types[t]].doss[d][ctypes[ct]][c]));
                                        codeOut.code_type = (ctypes[ct] == "em" ? "cpt" : ctypes[ct]);
                                        codes.push(codeOut);
                                    }
                                }
                            }
                        }else{
                            for (let c=0; c<this.activeEnc.codes[types[t]].doss[d].dxs.length; c++){
                                let codeOut = JSON.parse(JSON.stringify(this.activeEnc.codes[types[t]].doss[d].dxs[c]));
                                codeOut.code_type = "dx";
                                codes.push(codeOut);
                            }
                        }
                    }
                };
            }
            // //// console.log(JSON.stringify(codes));
            let clen = codes.length;
            for (let m=0; m<this.mipsMeasures.length; m++){
                let mipMeas = this.mipsMeasures[m],
                    denoms = mipMeas.denominator.steps,
                    isTrue=[];
                //// console.log("MIP: " + mipMeas.mip + " D: " + denoms.length);
                for (let d=0; d<denoms.length; d++){
                    //// console.log("LOGIC: " + denoms[d].logic);
                    let outTF = false;
                    if(denoms[d].criteria_type == "age"){
                        if(denoms[d].criteria.min <= age && denoms[d].criteria.max >= age){
                            outTF = true;
                        }
                        //// console.log("AGE: " + denoms[d].criteria.min + " <= " + age + " >= " + denoms[d].criteria.max + " = " + outTF);
                    }else if(denoms[d].criteria_type == "gender"){
                        if(denoms[d].criteria == gender){
                            outTF = true;
                        }
                        //// console.log("GENDER: " + denoms[d].criteria + " == " + gender + " = " + outTF);
                    }else if(denoms[d].criteria_type == "code"){
                        for(let c=0; c<clen; c++){
                            //// console.log("CODE: " + JSON.stringify(codes[c]));
                            let code = (codes[c].code.code ? codes[c].code.code : codes[c].code);
                            if(denoms[d].logic == "AND_OR"){
                                for (let cc=0; cc<denoms[d].criteria.length; cc++){
                                    if(denoms[d].criteria[cc].code_type == "mod"){
                                        //// console.log("FIX MOD EVAL");
                                        outTF = true;
                                        //// console.log("AND_OR: " + denoms[d].criteria[cc].code_type + " = " + codes[c].code_type +" CODE: " + code + " = " + outTF);
                                        break;
                                    }else{
                                        if(denoms[d].criteria[cc].code_type == codes[c].code_type && denoms[d].criteria[cc].codes.includes(code)){
                                            outTF = true;
                                            //// console.log("AND_OR: " + denoms[d].criteria[cc].code_type + " = " + codes[c].code_type +" CODE: " + code + " = " + outTF);
                                            break;
                                        }
                                    }
                                    
                                }
                            }else if(denoms[d].logic == "AND_NOT"){
                                if(denoms[d].criteria.code_type == "mod" && codes[c].code_type != "dx"){
                                    let modFound = false;
                                    if(codes[c].mods.length>0){
                                        for (let m=0; m<codes[c].mods.length; m++){
                                            if(denoms[d].criteria.codes.includes(codes[c].mods[m])){
                                                outTF = false;
                                                modFound = true;
                                                //// console.log("AND_NOT: " + denoms[d].criteria.code_type + " = " + codes[c].code_type +" MOD: " + codes[c].mods[m] + " = " + outTF);
                                                break;
                                            }else{
                                                outTF = true;
                                            }
                                        }
                                        if(modFound){
                                            break;
                                        }
                                    }else{
                                        //// console.log("NO MODS");
                                        outTF = true;
                                    }
                                }else{
                                    if(denoms[d].criteria.code_type == codes[c].code_type && denoms[d].criteria.codes.includes(code)){
                                        outTF = true;
                                    }
                                }
                                //// console.log("LOGIC: " + denoms[d].logic + " " + denoms[d].criteria.code_type + " = " + codes[c].code_type +" CODE: " + code + " = " + outTF);
                            }else{
                                if(denoms[d].criteria.code_type == "mod"){
                                    //// console.log("FIX MOD EVAL");
                                    outTF = true;
                                }else{
                                    if(denoms[d].criteria.code_type == codes[c].code_type && denoms[d].criteria.codes.includes(code)){
                                        outTF = true;
                                    }
                                }
                                //// console.log("LOGIC: " + denoms[d].logic + " " + denoms[d].criteria.code_type + " = " + codes[c].code_type +" CODE: " + code + " = " + outTF);
                            }
                            // if(outTF){
                            //     break;
                            // }
                        }
                    }
                    // if(denoms[d].logic == "AND_NOT"){
                    //     outTF = !outTF;
                    //     //// console.log("AND_NOT: " + denoms[d].criteria.code_type + " = " + outTF);
                    // }
                    isTrue.push(outTF);
                }
                //// console.log(JSON.stringify(isTrue));
                if(!isTrue.includes(false)){
                    //// console.log("MIP COULD BE ADDED...")
                    let mipExist = false,mipind,mipinfo;
                    for(let m=0; m<this.activeEnc.codes.mips.length; m++){
                        //// console.log("NEW MIP: " + mipMeas.id + " =? EXISTING MIP: " + this.activeEnc.codes.mips[m].mip_id);
                        if(mipMeas.id == this.activeEnc.codes.mips[m].mip_id){
                            mipExist = true;
                            mipind = m;
                            mipinfo = this.activeEnc.codes.mips[m];
                            break;
                        }
                    }
                    this.mipsSelected[mipMeas.id] = mipMeas;
                    this.mSteppers[this.activeEnc.codes.mips.length-1] = 1;
                    
                    if(!mipExist){
                        this.activeEnc.codes.mips.push({
                            "id":ulid(),
                            "mip": mipMeas.mip,
                            "mip_id": mipMeas.id,
                            "code":""
                        });
                        let ind = this.activeEnc.codes.mips.length-1;
                        this.mipSelects[mipMeas.id] = [false];
                        this.mipsPanels[ind] = 0;
                    }else{
                        //// console.log("MIP ALREADY EXISTS!");
                        this.mipSelects[mipMeas.id] = []
                        for(let s=0; s<this.mipsSelected[mipinfo.mip_id].numerator.steps.length; s++){
                            if(mipinfo.code==this.mipsSelected[mipinfo.mip_id].numerator.steps[s].code){
                                this.mipSelects[mipMeas.id][s] = true;
                                this.mSteppers[mipind] = s+1;
                                this.msc++;
                            }else{
                                this.mipSelects[mipMeas.id][s] = false;
                            }
                        }
                        this.mipsPanels[mipind] = 0;
                        
                    }
                }else{
                    //// console.log("MIP CANNOT BE ADDED!");
                    let mipExist = false,mipind;
                    for(let m=0; m<this.activeEnc.codes.mips.length; m++){
                        //// console.log("NEW MIP: " + mipMeas.id + " =? EXISTING MIP: " + this.activeEnc.codes.mips[m].mip_id);
                        if(mipMeas.id == this.activeEnc.codes.mips[m].mip_id){
                            mipExist = true;
                            mipind = m;
                            break;
                        }
                    }
                    if(mipExist){
                        //// console.log("MIP EXISTS, LET'S REMOVE IT!");
                        this.activeEnc.codes.mips.splice(mipind, 1);
                    }
                }
            }
            //// console.log(JSON.stringify(this.activeEnc.codes.mips));
            this.mipchange++;
        },
        goToStep(mid,sind){
            for(let m=0; m<this.mipSelects[mid].length; m++){
                if(sind != m){
                    this.mipSelects[mid][m] = false;
                }
            }
        },
        mipCodeChecked(val,mind,mip,code){
            //// console.log(mind + ": " + mip + " - " + code + " = " + val);
            this.activeEnc.codes.mips[mind].code = (val ? code : "");
            this.msc++;
        },
        mipStepChange(d,mind,sind,mid){
            //// console.log("IN: " + this.mSteppers[mind]);
            if(d=="F"){
                this.mSteppers[mind]++;
                this.mipSelects[mid][sind] = false;
            }else if(d=="B"){
                this.mSteppers[mind]--;
                this.mipSelects[mid][sind] = false;
            }
            //// console.log("OUT: " + this.mSteppers[mind]);
            this.msc++;
        },
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        clearResultsDialog(){
            this.clearResDiag = true;
            let d = new Date().getTime(),
                diff = Math.abs(d - this.timeOpened),
                out = Math.floor((diff/1000)/60);
            this.timeSinceOpen = out;
        },
        clearResults(){
            this.clearResDiag = false;
            this.undoEnc = JSON.parse(JSON.stringify(this.iniVal));
            this.iniVal.entries = {
                
            };
            for(let c=this.iniCDIs.length-1; c>=0; c--){
                if(this.iniCDIs[c].infid){
                    this.iniCDIs.splice(c, 1);
                }
            }
            this.iniVal.results = [];
            this.lastChanceUndo = true;
            this.countdownTimer();
        },
        undoResults(){
            this.iniVal = this.undoEnc;
            this.lastChanceUndo = false;
            clearInterval(this.countdownInt);
        },
        countdownTimer(){
            ////// console.log("COUNTING DOWN " + this.undoTimeLeft);
            const self = this;
            this.countdownInt = setInterval(function() {
                ////// console.log("TL: " + self.undoTimeLeft);
                self.undoTimeLeft--;
                if (self.undoTimeLeft < 0) {
                    ////// console.log("TIMER DONE");
                    clearInterval(self.countdownInt);
                    self.lastChanceUndo = false;
                    self.undoEnc = {};
                    self.undoTimeLeft = 15;
                }
            }, 1000);
        },
        infValid(ind){
            let fComb = "INF_" + ind + "_drug";
            let out = false;
            if(this.reqCheck(fComb)){
                ////// console.log(ind + " inf REQUIRED!");
                ////// console.log("VALUE: " + JSON.stringify(this.iniVal.entries.inf[ind].drug));
                if(this.iniVal.entries.inf[ind].drug == "" || !this.iniVal.entries.inf[ind].drug){
                    out = false;
                }else{
                    out = true;
                }
            }else{
                out = true
            }
            return out;
        },
        validateform(){
            this.validate();
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            ////// console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        cdiInline(verb,infid,area){
            ////// console.log("CDI INLINE: " + verb + " | " + area);
            if(verb == "add"){
                this.iniCDIs.push({"area": area,"qty": 1,"clinical_resource": "","note": "","infid":infid});
                this.forceFormValidate('iniform');
            }else if(verb == "del"){
                if(this.iniCDIs.length == 0){
                    this.iniCDIs[0] = {"area": "","qty": 1,"clinical_resource": "","note": ""};
                }else{
                    for(let c=this.iniCDIs.length-1; c>=0; c--){
                        if(this.iniCDIs[c].infid == infid){
                            if(this.iniCDIs[c].area == area || area == "all"){
                                this.iniCDIs.splice(c, 1);
                            }
                        }
                    }
                } 
            }
        },
        formatTime(inp){
            ////// console.log(inp); // "([01]?[0-9]|2[0-3]):[0-5][0-9]"
            let out = "00:00";

            return inp;
        },
        dtConvert(dos,time,type,nd){
            ////// console.log(dos + " | " + time + " | " + type + " | " + nd);
            let out = null,preout;
            if(type == "stop" && time && nd){
                let d = new Date(dos + " " + "12:00"),
                        dp = new Date(d.getTime() + 86400000),
                        dateplus = dp.toISOString().split("T")[0];
                // //// console.log(d);
                // //// console.log(dp);
                // //// console.log(dateplus);
                preout = new Date(dateplus + " " + time);
                out = preout.getTime();
            }else if(time){
                preout = new Date(dos + " " + time);
                out = preout.getTime();
            }
            return out;
        },
        allCapArray(arr){
            ////// console.log("IN: " + JSON.stringify(arr));
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                ////// console.log("IND: " + ind);
                ////// console.log("A: " + a);
                if(ind != -1 && ind != a){
                    //arr.splice(a,1);
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            ////// console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        forceFormValidate(form){
            ////// console.log("FORCE VALIDATE: " + form);
            this.$refs[form].validate();
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid);
                return provDet.displayName + " (" + uuid + ")";
            }else{
                return "";
            }
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            ////// console.log("CALC AGE");
            this.menudob = false;
        },
        ageTator(dobin){
            ////// console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
    .nextDay label{
        font-size: 14px;
        line-height: 14px !important;
        margin-left: -5px;
    }
    .theme--dark.v-tabs-items{
        background-color: unset;
    }
    .largeCbox i{
        font-size: 35px !important;
        margin-left: 75% !important;
        margin-top: -10px !important;
    }
    .largeCbox .v-input--selection-controls__ripple{
        margin-left: 100% !important;
        margin-top: 3px !important;
    }
    .step50 .v-stepper{
        height: 50px !important;
    }
    .step50 .v-stepper__header{
        height: 50px !important;
    }
    .step50 .v-stepper__step{
        padding: 12px 24px !important;
    }
</style>